import {inflate} from 'pako';

/**
 * Jobs utils class
 */
export abstract class JobsUtils {
    public static readonly JOBS_SPECIFICATION_APP_DETAILS_COMPRESS_PASS = 2;

    /**
     * Deserialize and decompress specification app details
     * @param serializedSpeficiationAppDetails Serialized specification app details
     * @returns Deserialized and decompressed specification app details
     */
    public static deserializeSpecificationAppDetails(
        serializedSpeficiationAppDetails: string
    ): Record<string, unknown> {
        const base64ToUint8Array = (b64: string): Uint8Array => {
            const binary = atob(b64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            return bytes;
        };

        let data: string = serializedSpeficiationAppDetails;
        const textEncoder = new TextDecoder('utf-8');

        for (let i = 0; i < JobsUtils.JOBS_SPECIFICATION_APP_DETAILS_COMPRESS_PASS - 1; i++) {
            try {
                const inflated = inflate(base64ToUint8Array(data));
                data = textEncoder.decode(inflated);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (exception: any) {
                throw new Error(`Failed to decompress at pass ${i + 1}: ${exception}`);
            }
        }

        try {
            const inflated = inflate(base64ToUint8Array(data));
            data = textEncoder.decode(inflated);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (exception: any) {
            throw new Error(`Failed to decompress initial layer: ${exception}`);
        }

        try {
            return JSON.parse(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (exception: any) {
            throw new Error(`Failed to decode JSON: ${exception}`);
        }
    }
}
